import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";

const RequestAccountVerification = async (uid, Count) => {
  console.log("uid", uid);
  console.log("count", Count);
  try {
    const UserDocument = doc(db, "Users", uid);

    const record = {
      IsVerified: 0,
      Count: Count + 1,
    };
    await updateDoc(UserDocument, record, { merge: true });
    return true;
  } catch (error) {
    console.log(error);
  }
};

export default RequestAccountVerification;
